import { createSlice } from "@reduxjs/toolkit";

import { fetchPilotTrackerData } from "../thunks/pilotTrackerThunks";

import type { PilotTrackerMovement } from "../../utils/types/pilotTracker";

interface PilotTrackerState {
  movements: PilotTrackerMovement[];
  loading: boolean;
  error: string | null;
  isDataFetched: boolean;
  lastSyncedAt: string | null;
}

const initialState: PilotTrackerState = {
  movements: [],
  loading: false,
  error: null,
  isDataFetched: false,
  lastSyncedAt: null,
};

export const pilotTrackerSlice = createSlice({
  name: "pilotTracker",
  initialState,
  reducers: {
    clearPilotTracker: (state) => {
      state.movements = [];
      state.isDataFetched = false;
      state.error = null;
      state.lastSyncedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPilotTrackerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPilotTrackerData.fulfilled, (state, action) => {
        state.movements = action.payload.data;
        state.lastSyncedAt = action.payload.lastSyncedAt;
        state.loading = false;
        state.isDataFetched = true;
      })
      .addCase(fetchPilotTrackerData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
        state.isDataFetched = false;
      });
  },
});

export const { clearPilotTracker } = pilotTrackerSlice.actions;
export default pilotTrackerSlice.reducer;
